var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Malaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M15.326,42h17.348c1.647-0.795,3.166-1.804,4.524-3H10.802C12.16,40.196,13.679,41.205,15.326,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M27,24h17c0-1.022-0.101-2.019-0.249-3H27V24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M27,18h16.082c-0.327-1.042-0.753-2.039-1.239-3H27V18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M32.674,6C30.91,5.148,29.006,4.552,27,4.249V6H32.674z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M4.249,27c0.155,1.025,0.365,2.032,0.669,3h38.163c0.304-0.968,0.515-1.975,0.669-3H27H4.249z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M8.027,36h31.946c0.708-0.94,1.335-1.941,1.87-3H6.157C6.692,34.059,7.32,35.06,8.027,36z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M27,12h12.973c-0.822-1.093-1.75-2.098-2.775-3H27V12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,44c3.112,0,6.047-0.732,8.674-2H15.326C17.953,43.268,20.888,44,24,44z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10.802,39h26.396c1.025-0.902,1.952-1.907,2.775-3H8.027C8.849,37.093,9.777,38.098,10.802,39z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M6.157,33h35.686c0.486-0.961,0.911-1.958,1.239-3H4.918C5.246,31.042,5.671,32.039,6.157,33z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27,27h16.751C43.899,26.019,44,25.022,44,24H27V27z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27,21h16.751c-0.155-1.025-0.365-2.032-0.669-3H27V21z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27,15h14.843c-0.535-1.059-1.163-2.06-1.87-3H27V15z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27,6v3h10.198c-1.358-1.196-2.877-2.205-4.524-3H27z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#311b92",
    d: "M27,24v-3v-3v-3v-3V9V6V4.249C26.019,4.101,25.022,4,24,4C12.954,4,4,12.954,4,24 c0,1.022,0.101,2.019,0.249,3H27V24z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M14.02,11.07c-3.324,0-6.02,2.688-6.02,6s2.695,6,6.02,6c1.203,0,2.32-0.352,3.258-0.957 c-0.547,0.191-1.133,0.293-1.742,0.293C12.586,22.406,10,19.938,10,17s2.586-5.234,5.531-5.234c0.652,0,1.277,0.117,1.855,0.332 C16.426,11.449,15.266,11.07,14.02,11.07z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M25.004,20.121l-2.535-1.32l0.75,2.707l-1.695-2.266L20.992,22l-0.52-2.758l-1.703,2.262l0.758-2.707 l-2.539,1.316l1.887-2.117L16,18.105l2.641-1.109l-2.637-1.117l2.875,0.117l-1.883-2.121l2.535,1.324l-0.75-2.707l1.699,2.266 L21.008,12l0.52,2.758l1.703-2.262l-0.758,2.707l2.539-1.316l-1.887,2.117L26,15.895l-2.641,1.109l2.637,1.117l-2.875-0.117 L25.004,20.121z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Malaysia);
export default __webpack_public_path__ + "static/media/icons8-malaysia.9658bae6348e1679231f51df3d5098f0.svg";
export { ForwardRef as ReactComponent };